import { CatalogItem } from './CatalogItem';

export const catalogItemSizeList = [
  '1x1-size',
  '2x1-size',
  '3x1-size',
  '2x2-size',
  '3x2-size',
  '3x3-size',
  'other-size'
] as const;

export type CatalogItemSize = typeof catalogItemSizeList[number];

function is1x1Size(item: CatalogItem) {
  const sid = item.item_size_id;
  return sid === '1x1' || sid === '0.5x0.5' || sid === '1x0.5' || sid === '0.5x1';
}

function is2x1Size(item: CatalogItem) {
  const sid = item.item_size_id;
  return (
    sid === '2x1' ||
    sid === '1x2' ||
    sid === '2x0.5' ||
    sid === '0.5x2' ||
    sid === '1.5x1' ||
    sid === '1x1.5'
  );
}

function is3x1Size(item: CatalogItem) {
  const sid = item.item_size_id;
  return (
    sid === '3x1' ||
    sid === '1x3' ||
    sid === '3x0.5' ||
    sid === '0.5x3' ||
    sid === '2.5x1' ||
    sid === '1x2.5'
  );
}

function is2x2Size(item: CatalogItem) {
  const sid = item.item_size_id;
  return sid === '2x2' || sid === '1.5x1.5' || sid === '2x1.5' || sid === '1.5x2';
}

function is3x2Size(item: CatalogItem) {
  const sid = item.item_size_id;
  return (
    sid === '3x2' ||
    sid === '2x3' ||
    sid === '3x1.5' ||
    sid === '1.5x3' ||
    sid === '2.5x2' ||
    sid === '2x2.5'
  );
}

function is3x3Size(item: CatalogItem) {
  const sid = item.item_size_id;
  return sid === '3x3' || sid === '2.5x2.5' || sid === '2.5x3' || sid === '3x2.5';
}

export function isSizeEqual(size: CatalogItemSize, item: CatalogItem): boolean {
  switch (size) {
    case '1x1-size':
      return is1x1Size(item);
    case '2x1-size':
      return is2x1Size(item);
    case '3x1-size':
      return is3x1Size(item);
    case '2x2-size':
      return is2x2Size(item);
    case '3x2-size':
      return is3x2Size(item);
    case '3x3-size':
      return is3x3Size(item);
    case 'other-size':
      return (
        !is1x1Size(item) &&
        !is2x1Size(item) &&
        !is3x1Size(item) &&
        !is2x2Size(item) &&
        !is3x2Size(item) &&
        !is3x3Size(item)
      );
  }
}
